// utils/sessionUtils.js
import axios from "axios";
export const clearSessionStorage = () => {
  sessionStorage.clear();
};

export const saveSessionData = (data) => {
  Object.keys(data).forEach((key) => {
    sessionStorage.setItem(key, JSON.stringify(data[key]));
  });
};

export const validateCredentials = async (branch, username, password) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_COLLEGE_ERP_API}auth`,
      { branch, username, password }
    );
    return response.data;
  } catch (error) {
    // Axios error handling
    throw new Error(
      error.response?.data?.message || "Failed to login. Please try again."
    );
  }
};
